// src/features/testimonials/TestimonialCard.jsx
import React from "react";
import { API_BASE } from "../../admin/api";

export default function TestimonialCard({ item, onEdit, onDelete }) {
  const imgSrc = item.image ? `${API_BASE}${item.image}` : null;

  // small helper to strip HTML for preview
  const plain = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html || "";
    return div.textContent || div.innerText || "";
  };

  return (
    <article className="t-card">
      <div className="t-card__thumb">
        {imgSrc ? (
          <img src={imgSrc} alt={item.person_name} loading="lazy" />
        ) : (
          <div className="t-card__thumb--empty">No Image</div>
        )}
        <div className={`t-card__badge ${item.status === "published" ? "is-pub" : "is-draft"}`}>
          {item.status}
        </div>
      </div>

      <div className="t-card__body">
        {item.title && <h4 className="t-card__title">{item.title}</h4>}
        <p className="t-card__msg">{plain(item.message).slice(0, 140)}{plain(item.message).length > 140 ? "…" : ""}</p>

        <div className="t-card__person">
          <div className="t-card__name">{item.person_name}</div>
          {item.designation && <div className="t-card__sub">{item.designation}</div>}
        </div>

        <div className="t-card__actions">
          <button className="btn btn--ghost" onClick={() => onEdit(item)} title="Edit">
            <span className="i i-edit" aria-hidden="true" /> Edit
          </button>
          <button className="btn btn--danger" onClick={() => onDelete(item.id)} title="Delete">
            <span className="i i-trash" aria-hidden="true" /> Delete
          </button>
        </div>
      </div>
    </article>
  );
}
